export const getApiBaseUrl = (): string => {
  const isProd =
    process.env.NEXT_PUBLIC_GITHUB_BRANCH === 'main';

  if (isProd) {
    return (
      process.env.NEXT_PUBLIC_BACKEND_BASE_MAIN_URL ??
      'https://prod.echargeup.com/'
    );
  }

  return (
    process.env.NEXT_PUBLIC_BACKEND_BASE_DEV_URL ??
    'https://dev.echargeup.com/'
  );
};

const validatedBaseUrl = getApiBaseUrl().endsWith('/')
  ? getApiBaseUrl()
  : `${getApiBaseUrl()}/`;

export const getFullUrl = (endpoint: string): string => {
  const cleanEndpoint = endpoint.startsWith('/')
    ? endpoint.slice(1)
    : endpoint;
  return `${validatedBaseUrl}${cleanEndpoint}`;
};
